import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { CustomTooltip } from '@AMIEWEB/Common/Tooltips/CustomTooltip';
import FolderCopyIcon from '@mui/icons-material/FolderCopyOutlined';
import React from 'react';
import { colors } from '../../../../styles/styleVariables';
import { selectPlacementStatus } from '../../../../store/redux-store/placement-status/selectors';
import { selectUser } from 'oidc/user.selectors';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Authorized } from 'oidc/userHelper';
import { userRoles } from 'oidc/userRoles';
export interface IHeaderLinkProps {
  closeCopyMenu: Function;
  openPlacementChangeDialog: Function;
}

export const PlacementChangeHeaderLink = (props: IHeaderLinkProps) => {
  const { t } = useTranslation();
  const { closeCopyMenu, openPlacementChangeDialog } = props;
  const { userInfo } = useSelector(selectUser);
  const { currentPlacementStatus } = useSelector(selectPlacementStatus);

  const hasPlacementChangePermission = Boolean(userInfo?.externalSystemDetails?.placementCopy);
  const isADRoleAuthorized = React.useMemo(
    () =>
      Authorized(
        [
          userRoles.accountManagement_Leadership,
          userRoles.accountManagement_TeamMember,
          userRoles.recruitment_Leadership,
          userRoles.candidate_Contracts_Leadership,
          userRoles.candidate_Contracts_TeamMember,
        ],
        userInfo
      ),
    [userInfo]
  );
  
  const hasPermissionToLink = React.useMemo(() => {
    return (
      (currentPlacementStatus?.activityTypeId === 4 &&
        currentPlacementStatus?.activityStatusId >= 15) ||
      (currentPlacementStatus?.activityTypeId === 5 &&
        currentPlacementStatus?.activityStatusId >= 23)
    );
  }, [currentPlacementStatus]);

  const disableReasons: string[] = [];
    if (!hasPlacementChangePermission) {
      disableReasons.push(t('placement.placementChange.disabledDueToUserAccess'));
    } else if (!isADRoleAuthorized) {
      disableReasons.push(t('placement.placementChange.disabledDueToUserAccess'));
    } else if (!hasPermissionToLink) {
      disableReasons.push(t('placement.placementChange.disabledDueToStatus'));
    }
const isDisabled = disableReasons.length > 0;

const tooltipMessage = disableReasons.length
  ? `${t('placement.placementChange.disabledDueTo')} ${disableReasons.join(', ')}`
  : '';
  return (
    <>
      {hasPlacementChangePermission && (
        <CustomTooltip
          tooltipContent={tooltipMessage}
          contentStyle={{ fontWeight: 400, color: colors.darkText }}
        >
          <ListItemButton
            id="placement-change-button"
            disabled={isDisabled}
            onClick={() => {
              closeCopyMenu();
              openPlacementChangeDialog();
            }}
          >
            <ListItemIcon>
              <FolderCopyIcon color="primary" fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={t('placement.placementChange.title')} />
          </ListItemButton>
        </CustomTooltip>
      )}
    </>
  );
};
